import CommonState from './CommonState'

/** 系统常量 **/
/**
 * 默认签单天数
 */
export const COMPANY_DEFAULT_SIGNED_DAYS = 180

/**
 * 默认沉睡天数
 */
export const COMPANY_DEFAULT_SLEEP_DAYS = 365

/**
 * 业务特性CheckBox.id,CheckBox.name,前缀
 */
export const QUT_BUSINESS_DETAIL_CHECKBOX_PREF = 'BusinessDetail_CheckBox_'
// --------------
// 客户公司类型
// --------------
export const COMPANY_COMMERCIAL = new CommonState(0, '贸易公司', 'Commercial Company')
export const COMPANY_PRODUCTION_MARKETTING = new CommonState(1, '工贸一体化公司', 'Production and Marketing Company')
export const COMPANY_LOGISTICS = new CommonState(2, '物流公司', 'Logistics Company')
export const COMPANY_AGENT = new CommonState(3, '代理公司', 'Agent Company')
/**
 *
 * 客户公司类型:<br>
 * ["CC_001","贸易公司","Commercial Company"]<br>
 * ["CC_002","工贸一体化公司","Production and Marketing Company"]<br>
 * ["CC_003","物流公司","Logistics Company"]
 * ["CC_004","代理公司","Agent Company"]
 */
export const CUSTOMER_TYPE = [
  COMPANY_COMMERCIAL,
  COMPANY_PRODUCTION_MARKETTING,
  COMPANY_LOGISTICS,
  COMPANY_AGENT
]
// --------------

// --------------
// 客户状态
// --------------
export const STAGE_POTENTIAL = new CommonState(0, '潜在阶段', 'Potential Stage')
export const STAGE_CONTEMPLATION = new CommonState(1, '意向阶段', 'Contemplation Stage')
export const STAGE_BUSINESS = new CommonState(2, '商务阶段', 'Business Stage')
export const STAGE_COOPERATION = new CommonState(3, '合作阶段', 'Cooperation Stage')
/**
 * 客户状态<br>
 * "CC_021","潜在阶段","Potential Stage"<br>
 * "CC_022","意向阶段","Contemplation Stage"<br>
 * "CC_023","商务阶段","Business Stage"<br>
 * "CC_024","合作阶段","Cooperation Stage"
 */
export const CUSTOMER_STATUS = [
  STAGE_POTENTIAL,
  STAGE_CONTEMPLATION,
  STAGE_BUSINESS,
  STAGE_COOPERATION
]
/**
 * 非合作阶段可选内容
 */
export const CUSTOMER_STATUS_NO_COOPERATION = new Set([
  STAGE_POTENTIAL,
  STAGE_CONTEMPLATION,
  STAGE_BUSINESS
])

// --------------

// --------------
// 客户评定等级
// -------------
export const LEVEL_UPON_20TEU = new CommonState(0, 'A-货物出口稳定,每个月固定20TEU', 'A-Export Stability At 20 TEU')
export const LEVEL_UNDER_20TEU = new CommonState(1, 'B-出口较稳定,在20TEU下', 'B-Export Stability Under 20 TEU')
export const LEVEL_UNDER_5TEU = new CommonState(2, 'C-出口稳定,每个月5TEU以内', 'C-Export Stability Under 5 TEU')

/**
 * 客户评定等级<br>
 * "CC_041","A-货物出口稳定,每个月固定20TEU","A-Export Stability At 20 TEU"<br>
 * "CC_042","B-出口较稳定,在20TEU下","B-Export Stability Under 20 TEU"<br>
 * "CC_043","C-出口稳定,每个月5TEU以内","C-Export Stability Under 5 TEU"
 */
export const CUSTOMER_EXPORT_LEVEL = new Set([
  LEVEL_UPON_20TEU,
  LEVEL_UNDER_20TEU,
  LEVEL_UNDER_5TEU
])
// -------------

// --------------
// 攻克难度指数
// --------------
export const DIFFICULTY_AAA = new CommonState(0, 'AAA-有固定合作代理,内部关系一年内不换', 'AAA:Stability Relationship')
export const DIFFICULTY_AA = new CommonState(1, 'AA:每年招标根据情况,可以看看2-3个月', 'AA:Depending On Circumstances,MayBe 2 - 3 Months')
export const DIFFICULTY_A = new CommonState(2, 'A:只要便宜就考虑', 'A:Only When It Cheap')
export const DIFFICULTY_B = new CommonState(3, 'B:便宜就考虑,给老板推荐', 'B:Introduce To Boss  When It Cheap')
export const DIFFICULTY_C = new CommonState(4, 'C:便宜就考虑,准备换代理', 'C:May Change Agent,Consider When It Cheap')

/**
 * 攻克难度指数<br>
 * "CC_061","AAA-有固定合作代理,内部关系一年内不换","AAA:Stability Relationship"<br>
 * "CC_062","AA:每年招标根据情况,可以看看2-3个月","AA:Depending On Circumstances,MayBe 2 - 3 Months"<br>
 * "CC_063","A:只要便宜就考虑","A:Only When It Cheap"<br>
 * "CC_064","B:便宜就考虑,给老板推荐","B:Introduce To Boss  When It Cheap"<br>
 * "CC_065","C:便宜就考虑,准备换代理","C:May Change Agent,Consider When It Cheap"
 */
export const CUSTOMER_DIFFICULTY_LEVEL = new Set([
  DIFFICULTY_AAA,
  DIFFICULTY_AA,
  DIFFICULTY_A,
  DIFFICULTY_B,
  DIFFICULTY_C
])
// -------------

// --------------
// 走货类型
// --------------
export const WAY_SEA = new CommonState('海运', '海运', 'Sea Way')
export const WAY_AIR = new CommonState('空运', '空运', 'AIR WAY')
export const WAY_RAIL = new CommonState('铁路', '铁路', 'RAILWAY')

/**
 * 走货类型<br>
 * "CC_081","海运","Sea Way"<br>
 * "CC_081","空运","AIR WAY"<br>
 * "CC_083","铁路","RAILWAY"
 */
export const CUSTOMER_DELIVER_WAY = new Set([
  WAY_SEA,
  WAY_AIR,
  WAY_RAIL
])
// -------------

// --------------
// 常用贸易条款
// --------------
export const TRADE_CLAUSE_CIF = new CommonState('CIF', 'CIF', 'CIF')
export const TRADE_CLAUSE_FOB = new CommonState('FOB', 'FOB', 'FOB')
export const TRADE_CLAUSE_DDP = new CommonState('DDP', 'DDP', 'DDP')
export const TRADE_CLAUSE_DDU = new CommonState('DDU', 'DDU', 'DDU')
export const TRADE_CLAUSE_EXW = new CommonState('EXW', 'EXW', 'EXW')

/**
 * 常用贸易条款<br>
 * "CC_101","CIF","CIF"<br>
 * "CC_102","FOB","FOB"<br>
 * "CC_103","DDP","DDP"<br>
 * "CC_104","DDU","DDU"<br>
 * "CC_105","EXW","EXW"
 */
export const CUSTOMER_CLAUSE_TRADE = new Set([
  TRADE_CLAUSE_CIF,
  TRADE_CLAUSE_FOB,
  TRADE_CLAUSE_DDP,
  TRADE_CLAUSE_DDU,
  TRADE_CLAUSE_EXW
])
// -------------

// --------------
// 常用运输条款
// --------------
export const TRANSPORT_CLAUSE_CY_CY = new CommonState('CY_CY', 'CY_CY', 'CY_CY')
export const TRANSPORT_CLAUSE_CFS_CFS = new CommonState('CFS_CFS', 'CFS_CFS', 'CFS_CFS')
export const TRANSPORT_CLAUSE_DOOR_DOOR = new CommonState('DOOR_DOOR', 'DOOR_DOOR', 'DOOR_DOOR')

/**
 * 常用运输条款<br>
 * "CC_121","CY_CY","CY_CY"<br>
 * "CC_122","CFS_CFS","CFS_CFSB"<br>
 * "CC_123","DOOR_DOOR","DOOR_DOORP"
 */
export const CUSTOMER_TRANSPORT_CLAUSE = new Set([
  TRANSPORT_CLAUSE_CY_CY,
  TRANSPORT_CLAUSE_CFS_CFS,
  TRANSPORT_CLAUSE_DOOR_DOOR
])

// --------------
// 客户分配状态
// --------------
export const CUSTOMER_ASSIGN_STATUS_ALL = new CommonState(-1, '全部', 'UnderWay')
export const CUSTOMER_ASSIGN_STATUS_DONE = new CommonState(1, '已分配', 'UnderWay')
export const CUSTOMER_ASSIGN_STATUS_NORMAL = new CommonState(0, '未分配', 'UnderWay')

/**
 * 客户分配状态
 */
export const CUSTOMER_ASSIGN_STATUS = new Set([
  CUSTOMER_ASSIGN_STATUS_ALL,
  CUSTOMER_ASSIGN_STATUS_DONE,
  CUSTOMER_ASSIGN_STATUS_NORMAL
])

// --------------
// 事件主题
// --------------
export const CUSTOMER_EVENT_SUBJECT_C1 = new CommonState('实地拜访', '实地拜访', 'Field Investigation')
export const CUSTOMER_EVENT_SUBJECT_C2 = new CommonState('电话', '电话', 'Telephone')
export const CUSTOMER_EVENT_SUBJECT_C3 = new CommonState('即时通信(QQ/微信等)', '即时通信(QQ/微信等)', 'Instant Messaging (QQ/Wechat,etc.)')
export const CUSTOMER_EVENT_SUBJECT_C4 = new CommonState('电子邮件', '电子邮件', 'Email')
export const CUSTOMER_EVENT_SUBJECT_C5 = new CommonState('客户来访', '客户来访', 'Customer Visit')
export const CUSTOMER_EVENT_SUBJECT_C6 = new CommonState('熟客介绍', '熟客介绍', 'Frequent Visitor Introduction')
export const CUSTOMER_EVENT_SUBJECT_C7 = new CommonState('展会开发', '展会开发', 'Exhibition Development')

/**
 * 事件主题
 */
export const CUSTOMER_EVENT_SUBJECTS = [
  CUSTOMER_EVENT_SUBJECT_C1,
  CUSTOMER_EVENT_SUBJECT_C2,
  CUSTOMER_EVENT_SUBJECT_C3,
  CUSTOMER_EVENT_SUBJECT_C4,
  CUSTOMER_EVENT_SUBJECT_C5,
  CUSTOMER_EVENT_SUBJECT_C6,
  CUSTOMER_EVENT_SUBJECT_C7
]

// --------------
// 事件状态
// --------------
export const CUSTOMER_EVENT_STATUS_C1 = new CommonState('进行中', '进行中', 'Progress')
export const CUSTOMER_EVENT_STATUS_C2 = new CommonState('已完成', '已完成', 'Completed')
export const CUSTOMER_EVENT_STATUS_C3 = new CommonState('异常', '异常', 'Exception')

/**
 * 事件状态
 */
export const CUSTOMER_EVENT_STATUSS = [
  CUSTOMER_EVENT_STATUS_C1,
  CUSTOMER_EVENT_STATUS_C2,
  CUSTOMER_EVENT_STATUS_C3
]

// --------------
// 业务特性
// --------------
export const CUSTOMER_CLIENTBUSINESS_T1 = new CommonState(1, '业务旺季', 'Bs_t1')
export const CUSTOMER_CLIENTBUSINESS_T2 = new CommonState(2, '偏好走货类型', 'Bs_t2')
export const CUSTOMER_CLIENTBUSINESS_T3 = new CommonState(3, '偏好航线', 'Bs_t3')
export const CUSTOMER_CLIENTBUSINESS_T4 = new CommonState(4, '偏好港口(海港)', 'Bs_t4')
export const CUSTOMER_CLIENTBUSINESS_T5 = new CommonState(5, '偏好港口(空港)', 'Bs_t5')
export const CUSTOMER_CLIENTBUSINESS_T6 = new CommonState(6, '常用贸易条款', 'Bs_t6')
export const CUSTOMER_CLIENTBUSINESS_T7 = new CommonState(7, '偏好船公司', 'Bs_t7')
export const CUSTOMER_CLIENTBUSINESS_T8 = new CommonState(8, '偏好航空公司', 'Bs_t8')
export const CUSTOMER_CLIENTBUSINESS_T9 = new CommonState(9, '偏好运输条款', 'Bs_t9')
export const CUSTOMER_CLIENTBUSINESS_T10 = new CommonState(10, '偏好报关服务', 'Bs_t10')
export const CUSTOMER_CLIENTBUSINESS_T11 = new CommonState(11, '偏好拖车服务', 'Bs_t11')

// --------------
// 业务特性（月份）
// --------------
export const CUSTOMER_CLIENTBUSINESS_JAN = new CommonState('Jan', '1月', 'Jan')
export const CUSTOMER_CLIENTBUSINESS_FEB = new CommonState('Feb', '2月', 'Feb')
export const CUSTOMER_CLIENTBUSINESS_MAR = new CommonState('Mar', '3月', 'Mar')
export const CUSTOMER_CLIENTBUSINESS_APR = new CommonState('Apr', '4月', 'Apr')
export const CUSTOMER_CLIENTBUSINESS_MAY = new CommonState('May', '5月', 'May')
export const CUSTOMER_CLIENTBUSINESS_JUNE = new CommonState('June', '6月', 'June')
export const CUSTOMER_CLIENTBUSINESS_JULY = new CommonState('July', '7月', 'July')
export const CUSTOMER_CLIENTBUSINESS_AUG = new CommonState('Aug', '8月', 'Aug')
export const CUSTOMER_CLIENTBUSINESS_SEPT = new CommonState('Sept', '9月', 'Sept')
export const CUSTOMER_CLIENTBUSINESS_OCT = new CommonState('Oct', '10月', 'Oct')
export const CUSTOMER_CLIENTBUSINESS_NOV = new CommonState('Nov', '11月', 'Nov')
export const CUSTOMER_CLIENTBUSINESS_DEC = new CommonState('Dec', '12月', 'Dec')

// --------------
// 客户来源
// --------------
export const SOURCE_TYPE_SALE_EXTENSION = new CommonState(0, '销售自拓', 'Sale Extension')
export const SOURCE_TYPE_SALE_OBTAIN = new CommonState(1, '客户公海', 'Sale Obtain')
export const SOURCE_TYPE_LEADER_ASSIGN = new CommonState(2, '组长分配', 'Leader Assign')
export const SOURCE_TYPE_UNKNOW = new CommonState(5, '无', 'Unknow')

/**
 * 客户来源
 */
export const SOURCE_TYPE = [
  SOURCE_TYPE_SALE_EXTENSION,
  SOURCE_TYPE_SALE_OBTAIN,
  SOURCE_TYPE_LEADER_ASSIGN
]

/**
 * 客户来源
 */
export const SOURCE_TYPE_GRID = [
  SOURCE_TYPE_SALE_EXTENSION,
  SOURCE_TYPE_SALE_OBTAIN,
  SOURCE_TYPE_LEADER_ASSIGN,
  SOURCE_TYPE_UNKNOW
]

// --------------
// 客户接触渠道
// --------------
export const CUSTOMER_CONTACT_CHANNEL_UNKNOW = new CommonState(0, '无', 'Unknow')
export const CUSTOMER_CONTACT_CHANNEL_WEBSITE = new CommonState(1, '公司官网', 'Website')
export const CUSTOMER_CONTACT_CHANNEL_CUSTOMER_SERVICE = new CommonState(2, '客服留言', 'Customer service')
export const CUSTOMER_CONTACT_CHANNEL_BAIDU = new CommonState(3, '百度信息流', 'Baidu')
export const CUSTOMER_CONTACT_CHANNEL_58COM = new CommonState(4, '58同城', '58.com')
export const CUSTOMER_CONTACT_CHANNEL_WECHAT_QQ = new CommonState(5, '微信/QQ', 'Wechat/QQ')
export const CUSTOMER_CONTACT_CHANNEL_QQENTERPRISE = new CommonState(6, 'QQ企点', 'QQ Enterprise')
export const CUSTOMER_CONTACT_CHANNEL_COMPANY_TELEPHONE = new CommonState(7, '公司电话', 'Company Telephone')
export const CUSTOMER_CONTACT_CHANNEL_NETWORK = new CommonState(8, '网络', 'Network')
export const CUSTOMER_CONTACT_CHANNEL_EXHIBITION = new CommonState(9, '展会', 'Exhibition')
export const CUSTOMER_CONTACT_CHANNEL_CUSTOMER_INTRODUCTION = new CommonState(10, '客户介绍', 'Customer Introduction')
export const CUSTOMER_CONTACT_CHANNEL_PERSONAL_CHANNEL = new CommonState(11, '个人渠道', 'Personal Channel')
export const CUSTOMER_CONTACT_CHANNEL_STOREHOUSE = new CommonState(12, '库房', 'Storehouse')
export const CUSTOMER_CONTACT_CHANNEL_OTHER_CHANNEL = new CommonState(13, '其他渠道', 'Other Channel')
export const CUSTOMER_CONTACT_CHANNEL_COMPANY_DATA = new CommonState(14, '公司数据', 'Company Data')

/**
 * 客户接触渠道
 */
export const CUSTOMER_CONTACT_CHANNEL = [
  CUSTOMER_CONTACT_CHANNEL_WEBSITE,
  CUSTOMER_CONTACT_CHANNEL_CUSTOMER_SERVICE,
  CUSTOMER_CONTACT_CHANNEL_BAIDU,
  CUSTOMER_CONTACT_CHANNEL_58COM,
  CUSTOMER_CONTACT_CHANNEL_WECHAT_QQ,
  CUSTOMER_CONTACT_CHANNEL_QQENTERPRISE,
  CUSTOMER_CONTACT_CHANNEL_COMPANY_TELEPHONE,
  CUSTOMER_CONTACT_CHANNEL_NETWORK,
  CUSTOMER_CONTACT_CHANNEL_EXHIBITION,
  CUSTOMER_CONTACT_CHANNEL_CUSTOMER_INTRODUCTION,
  CUSTOMER_CONTACT_CHANNEL_PERSONAL_CHANNEL,
  CUSTOMER_CONTACT_CHANNEL_STOREHOUSE,
  CUSTOMER_CONTACT_CHANNEL_OTHER_CHANNEL
]

/**
 * 客户接触渠道
 */
export const CUSTOMER_CONTACT_CHANNEL_GRID = [
  CUSTOMER_CONTACT_CHANNEL_WEBSITE,
  CUSTOMER_CONTACT_CHANNEL_CUSTOMER_SERVICE,
  CUSTOMER_CONTACT_CHANNEL_BAIDU,
  CUSTOMER_CONTACT_CHANNEL_58COM,
  CUSTOMER_CONTACT_CHANNEL_WECHAT_QQ,
  CUSTOMER_CONTACT_CHANNEL_QQENTERPRISE,
  CUSTOMER_CONTACT_CHANNEL_COMPANY_TELEPHONE,
  CUSTOMER_CONTACT_CHANNEL_NETWORK,
  CUSTOMER_CONTACT_CHANNEL_EXHIBITION,
  CUSTOMER_CONTACT_CHANNEL_CUSTOMER_INTRODUCTION,
  CUSTOMER_CONTACT_CHANNEL_PERSONAL_CHANNEL,
  CUSTOMER_CONTACT_CHANNEL_STOREHOUSE,
  CUSTOMER_CONTACT_CHANNEL_OTHER_CHANNEL,
  CUSTOMER_CONTACT_CHANNEL_COMPANY_DATA,
  CUSTOMER_CONTACT_CHANNEL_UNKNOW
]
